import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import GenericForm from "../../components/forms/GenericForm";
import {
    getCookie,
    mergeFormData,
    prepareForm,
    simplePostData,
    simplePutData
} from '../../utils/Functions';
import Utils from "../../utils/Utils";
import {CircularProgress, Container, Grid, TextField, Typography} from "@mui/material";

import Button from '@mui/material/Button';
import {useNavigate, useParams} from 'react-router-dom';
import EndPoint from "../../api/Endpoints";

import useMediaQuery from '@mui/material/useMediaQuery';
import {styled, useTheme} from '@mui/material/styles';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import LoaderButton from "../../components/forms/LoaderButton";
import {format} from 'date-fns';

import ticketOutline from "../../assets/imgs/unicef/messi/ticket-outline.png";
import jerseyFramed from "../../assets/imgs/unicef/messi/jersey-framed.png";

import "./MessiCheckout.css";

const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const {children, onClose, ...other} = props;
    return (
        <DialogTitle sx={{m: 0, p: 2}} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

var orderid = 0;
var tryout = 0;
var fieldType = "hidden";

const KidSvg = () => (
    <svg viewBox="0 0 50 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="kid-body">
        {/* Head */}
        <circle cx="25" cy="12" r="8" fill="#FFDBB5"/>
        {/* Hair */}
        <path d="M18 9 C18 5, 32 5, 32 9 C32 7, 18 7, 18 9Z" fill="#3d2314"/>
        {/* Happy face */}
        <circle cx="22" cy="11" r="1.2" fill="#333"/>
        <circle cx="28" cy="11" r="1.2" fill="#333"/>
        <path d="M22 15 Q25 18 28 15" stroke="#333" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
        {/* Body - UNICEF shirt */}
        <rect x="18" y="20" width="14" height="16" rx="3" fill="#00AEEF"/>
        {/* UNICEF text on shirt */}
        <text x="25" y="30" textAnchor="middle" fill="#fff" fontSize="4" fontWeight="bold">UNICEF</text>
        {/* Arms */}
        <line x1="18" y1="22" x2="12" y2="30" stroke="#FFDBB5" strokeWidth="3" strokeLinecap="round"/>
        <line x1="32" y1="22" x2="38" y2="28" stroke="#FFDBB5" strokeWidth="3" strokeLinecap="round"/>
        {/* Shorts */}
        <rect x="19" y="35" width="12" height="8" rx="2" fill="#0A1E3C"/>
        {/* Legs */}
        <line x1="22" y1="43" x2="20" y2="54" stroke="#FFDBB5" strokeWidth="3" strokeLinecap="round"/>
        <line x1="28" y1="43" x2="31" y2="54" stroke="#FFDBB5" strokeWidth="3" strokeLinecap="round"/>
        {/* Shoes */}
        <ellipse cx="19" cy="55" rx="4" ry="2.5" fill="#222"/>
        <ellipse cx="32" cy="55" rx="4" ry="2.5" fill="#222"/>
    </svg>
);

const BallSvg = () => (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9" fill="#fff" stroke="#333" strokeWidth="0.5"/>
        <path d="M10 1 L12 5 L10 9 L8 5 Z" fill="#333" opacity="0.7"/>
        <path d="M18 8 L15 10 L16 14 L19 12 Z" fill="#333" opacity="0.7"/>
        <path d="M2 8 L5 10 L4 14 L1 12 Z" fill="#333" opacity="0.7"/>
        <path d="M6 17 L8 14 L12 14 L14 17 Z" fill="#333" opacity="0.7"/>
        <circle cx="10" cy="10" r="3" fill="#333" opacity="0.6"/>
    </svg>
);

const GoalSvg = ({scored}) => (
    <svg viewBox="0 0 60 55" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Goal posts */}
        <rect x="5" y="5" width="4" height="48" rx="2" fill="#fff"/>
        <rect x="51" y="5" width="4" height="48" rx="2" fill="#fff"/>
        <rect x="5" y="3" width="50" height="4" rx="2" fill="#fff"/>
        {/* Net */}
        <g className="goal-net" opacity="0.5">
            <line x1="9" y1="7" x2="9" y2="53" stroke="#ccc" strokeWidth="0.5"/>
            <line x1="17" y1="7" x2="17" y2="53" stroke="#ccc" strokeWidth="0.5"/>
            <line x1="25" y1="7" x2="25" y2="53" stroke="#ccc" strokeWidth="0.5"/>
            <line x1="33" y1="7" x2="33" y2="53" stroke="#ccc" strokeWidth="0.5"/>
            <line x1="41" y1="7" x2="41" y2="53" stroke="#ccc" strokeWidth="0.5"/>
            <line x1="49" y1="7" x2="49" y2="53" stroke="#ccc" strokeWidth="0.5"/>
            <line x1="9" y1="15" x2="51" y2="15" stroke="#ccc" strokeWidth="0.5"/>
            <line x1="9" y1="25" x2="51" y2="25" stroke="#ccc" strokeWidth="0.5"/>
            <line x1="9" y1="35" x2="51" y2="35" stroke="#ccc" strokeWidth="0.5"/>
            <line x1="9" y1="45" x2="51" y2="45" stroke="#ccc" strokeWidth="0.5"/>
        </g>
        {scored && (
            <text x="30" y="32" textAnchor="middle" fill="#FFFA2F" fontSize="10" fontWeight="bold">GOL!</text>
        )}
    </svg>
);

const CelebrationStars = () => (
    <svg viewBox="0 0 60 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <text x="10" y="15" fontSize="12">⭐</text>
        <text x="30" y="10" fontSize="8">✨</text>
        <text x="45" y="20" fontSize="10">🌟</text>
    </svg>
);

const AnimationBanner = ({step}) => {
    const ballClass = step === 'personal' ? '' : step === 'payment' ? 'step-payment' : 'step-qr';
    const kidClass = step === 'personal' ? '' : step === 'payment' ? 'step-payment' : 'step-qr';
    const scored = step === 'qr';

    return (
        <div className="messi-animation-banner">
            <div className="field-line"/>
            <div className="grass"/>
            <div className={`messi-kid ${kidClass}`}>
                <KidSvg/>
            </div>
            <div className={`messi-ball ${ballClass}`}>
                <BallSvg/>
            </div>
            <div className={`messi-goal ${scored ? 'scored' : ''}`}>
                <GoalSvg scored={scored}/>
            </div>
            <div className={`celebration-stars ${scored ? 'visible' : ''}`}>
                <CelebrationStars/>
            </div>
        </div>
    );
};

const TicketBanner = ({amount}) => {
    const ticketCount = Math.floor(parseInt(amount) / 50);
    const displayTickets = Math.min(ticketCount, 5);

    return (
        <div className="messi-ticket-banner">
            <div className="ticket-icon-group">
                {Array.from({length: displayTickets}, (_, i) => (
                    <img key={i} src={ticketOutline} alt="" className="ticket-icon"/>
                ))}
                {ticketCount > 5 && (
                    <span style={{color: '#FFFA2F', fontWeight: 'bold', fontSize: '0.9rem', alignSelf: 'center'}}>
                        +{ticketCount - 5}
                    </span>
                )}
            </div>
            <div className="ticket-text">
                Tu donaci&oacute;n de <strong>Bs {amount}</strong> te da{' '}
                <strong>{ticketCount} ticket{ticketCount !== 1 ? 's' : ''}</strong>{' '}
                para el sorteo de la polera firmada por Messi
            </div>
        </div>
    );
};

const SorteoReminder = () => (
    <div className="messi-sorteo-reminder">
        <img src={jerseyFramed} alt="Polera"/>
        <p>
            Complet&aacute; tu donaci&oacute;n y particip&aacute;s del <strong>SORTEO</strong> de
            la polera oficial del FC Barcelona <strong>firmada por Lionel Messi</strong>
        </p>
    </div>
);

const MessiCheckout = (props) => {
    const navigate = useNavigate();
    const {defConfig, defLang} = useSelector((state) => state.Login);
    const [personaldata, setPersonaldata] = React.useState({});
    const [paymentdata, setPaymentdata] = React.useState({});

    const [personaldataSucc, setPersonaldataSucc] = React.useState(false);
    const [personaldataSuccQR, setPersonaldataSuccQR] = React.useState(false);
    const [noButton, setNoButton] = React.useState(false);
    const [formData, setFormData] = React.useState({});
    const [showCyberFrame, setShowCyberFrame] = React.useState(false);
    const [paymentToken, setPaymentToken] = React.useState({});
    const [loading, setLoading] = useState(false);
    const [showAmount, setShowAmount] = useState(false);
    const [amount, setAmount] = useState(0);
    const [checkedP, setCheckedP] = useState(true);
    const [loadingQR, setLoadingQR] = useState(false);
    const [imageQr, setImageQr] = useState("");
    const [idQR, setIdQR] = useState("");
    const [isLoadingVerificar, setIsLoadingVerificar] = useState("");
    const [mensajeQR, setMensajeQR] = useState("");
    const [errorQR, setErrorQR] = useState(false);
    const [tmpOrder, setTmpOrder] = React.useState({});
    const [stepQRValues, setStepQRValues] = React.useState({});

    const [finalData, setFinalData] = useState({access_key: "1"});
    const [signature, setSignature] = useState("");
    const [error, setError] = useState("");

    var date = new Date();
    var defDate = date.setMonth(date.getMonth() - (12 * 18));

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const fullScreen2 = useMediaQuery(theme.breakpoints.down('md'));
    const [open, setOpen] = React.useState(false);
    const [errMessage, setErrMessage] = React.useState("");

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleChangeP = (event) => setCheckedP(event.target.checked);

    const getCurrentStep = () => {
        if (personaldataSuccQR) return 'qr';
        if (personaldataSucc) return 'payment';
        return 'personal';
    };

    const eventAddPaymentMethod = () => {
        window.fbq('track', 'AddPaymentInfo');
        window.gtag("event", "add_payment_info", {
            currency: "BOB",
            value: amount,
            payment_type: "Credit Card",
            items: [{
                item_id: "SKU_DONACION",
                item_name: "Donación de " + amount + "Bs",
                price: amount,
                quantity: 1
            }]
        });
    };

    const confirmPersonalData = (values) => {
        if (checkedP) {
            if (personaldataSucc) {
                setPersonaldataSucc(true);
                setTimeout(() => setPersonaldataSucc(false), 1);
            } else {
                setPersonaldataSucc(true);
                eventAddPaymentMethod();
                let _formData = formData;
                Object.assign(_formData, values);
                setFormData(_formData);

                let utm_source = getCookie(process.env.REACT_APP_NAME + "utm_source");
                let stepValues = {
                    amount, step: "personal-info",
                    utm_source: utm_source,
                    birthday: values.birthday,
                    city: values.city,
                    dni: values.dni,
                    email: values.email,
                    firstname: values.firstname,
                    lastname: values.lastname,
                    phonenumber: (values.codenumber || values.phonecode || "+591") + values.phonenumber,
                    sessionid: tmpOrder
                };
                simplePutData(EndPoint.setStep, stepValues);
            }
        }
    };

    const confirmPersonalDataQR = async (values) => {
        setStepQRValues(values);
        setError(false);
        if (checkedP) {
            setPersonaldataSuccQR(true);
            eventAddPaymentMethod();
            let utm_source = getCookie(process.env.REACT_APP_NAME + "utm_source");
            let utm_id = getCookie(process.env.REACT_APP_NAME + "utm_id");
            let utm_content = getCookie(process.env.REACT_APP_NAME + "utm_content");
            let utm_medium = getCookie(process.env.REACT_APP_NAME + "utm_medium");
            let utm_campaign = getCookie(process.env.REACT_APP_NAME + "utm_campaign");
            let utm_term = getCookie(process.env.REACT_APP_NAME + "utm_term");
            let stepValues = {
                amount, step: "personal-info",
                utm_source,
                birthday: values.birthday,
                city: values.city,
                dni: values.dni,
                email: values.email,
                firstname: values.firstname,
                lastname: values.lastname,
                phonenumber: (values.codenumber || values.phonecode || "+591") + values.phonenumber,
                sessionid: tmpOrder,
                phonecode: values.codenumber || "+591",
                addressinfo: "",
                insert_user: "public",
                campaign: "messi",
                utm_id, utm_content, utm_medium, utm_campaign, utm_term,
            };

            setLoadingQR(true);
            await simplePostData(EndPoint.getQR, stepValues).then((response) => {
                if (response.imagenQr) {
                    setImageQr(response.imagenQr);
                    setIdQR(response.idQr);
                    setLoadingQR(false);
                    setErrorQR(false);
                } else {
                    setLoadingQR(false);
                    setErrorQR(true);
                }
            });
        }
    };

    const confirmPayment = async (values) => {
        let _formData = formData;
        Object.assign(_formData, values);
        setFormData(_formData);
        setLoading(true);
        setError("");

        _formData["amount"] = amount;

        if (_formData["birthday"] == "") {
            _formData["birthday"] = new Date(defDate);
        }
        setErrMessage("");
        let utm_source = getCookie(process.env.REACT_APP_NAME + "utm_source");
        let utm_id = getCookie(process.env.REACT_APP_NAME + "utm_id");
        let utm_content = getCookie(process.env.REACT_APP_NAME + "utm_content");
        let utm_medium = getCookie(process.env.REACT_APP_NAME + "utm_medium");
        let utm_campaign = getCookie(process.env.REACT_APP_NAME + "utm_campaign");
        let utm_term = getCookie(process.env.REACT_APP_NAME + "utm_term");

        _formData["utm_source"] = utm_source;
        _formData["utm_id"] = utm_id;
        _formData["utm_content"] = utm_content;
        _formData["utm_medium"] = utm_medium;
        _formData["utm_campaign"] = utm_campaign;
        _formData["utm_term"] = utm_term;

        if (_formData["codenumber"]) {
            _formData["phonecode"] = _formData["codenumber"];
        }

        _formData["cardnumber"] = _formData["cardnumber"].replaceAll(" ", "").replaceAll("-", "").replaceAll("_", "").trim();
        _formData["firstname"] = _formData["firstname"].replaceAll("-", " ").replaceAll("_", " ").trim();
        _formData["lastname"] = _formData["lastname"].replaceAll("-", " ").replaceAll("_", " ").trim();

        let stepValues = {
            amount,
            step: "checkout-order-step1",
            utm_source: utm_source,
            dni: _formData.dni,
            email: _formData.email,
            firstname: _formData.firstname,
            lastname: _formData.lastname,
            phonenumber: (_formData.phonecode || _formData.codenumber || "+591") + _formData.phonenumber,
            cardnumber: _formData.cardnumber,
            month: _formData.expiremonth,
            year: _formData.expireyear,
            cvv: _formData.cvv,
            sessionid: tmpOrder,
            utm_id, utm_content, utm_medium, utm_campaign, utm_term,
        };
        simplePutData(EndPoint.setStep, stepValues);

        _formData["phonenumber"] = (_formData.phonecode || _formData.codenumber || "+591") + _formData.phonenumber;

        var response = await simplePutData(EndPoint.createOrderOneShot, _formData);

        if (response.status) {
            tryout = 0;
            orderid = response.id;
            var data = {
                ci: _formData.dni,
                phone: _formData.phonenumber,
                nit: _formData.dni,
                amount: amount,
                referenceNumber: response.id,
                email: _formData.email,
                card_name: _formData.firstname,
                card_lastname: _formData.lastname,
                card_number: _formData.cardnumber,
                month: _formData.expiremonth,
                year: _formData.expireyear,
                cvv: _formData.cvv,
                device_fingerprint_id: tmpOrder,
                transaction_type: "sale",
                isOneShot: true,
                campaign: "messi"
            };
            response = await simplePostData(EndPoint.generateSignature, data);

            if (response.status) {
                setFinalData(response.data);
                setSignature(response.signature);

                setTimeout(async () => {
                    let stepValues = {
                        amount,
                        step: "checkout-cyber-step-2",
                        orderid: response.id,
                        utm_source: utm_source,
                        sessionid: tmpOrder
                    };
                    await simplePutData(EndPoint.setStep, stepValues);
                    document.getElementById("formCyberMessi").submit();
                }, 200);
            } else {
                setLoading(false);
                setError("Hubo un problema por favor intentelo nuevamente");
            }
        } else {
            setLoading(false);
            if (response.userInfo) {
                setErrMessage(response.message);
                handleOpen(true);
            } else {
                if (response.message === "INVALID") {
                    setError("Revise los datos de Carnet de identidad, nombres y teléfono");
                } else {
                    setError("Hubo un problema por favor intentelo nuevamente");
                }
            }
        }
    };

    const handleChange = (event) => {
        if (event.target.value === "") {
            setAmount(event.target.value);
        } else {
            if (/^[0-9]+$/.test(event.target.value)) {
                setAmount(event.target.value);
            }
        }
    };

    const callbackHandleChange = (field, value, postAction) => {
        if (field == "paymenttypecode") {
            if (value == "qr") {
                setNoButton(true);
            } else {
                setNoButton(false);
            }
        }
    };

    const loadData = async () => {
        let formpersonaldata = Utils.datos_personales;
        let formpaymentdata = Utils.datos_pago;

        let initialFormData = {
            amount: 0,
            shippingcost: 0,
            discount: 0,
            customerid: -1,
            phonecode: '+591',
            addressinfo: "",
            insert_user: "guest",
            cityid: 0,
            products: [],
        };
        setFormData(initialFormData);

        let userInfo = {};

        if (process.env.REACT_APP_dev_ftq == "YES") {
            userInfo = {
                firstname: "Franz",
                lastname: "Torrez",
                phonenumber: "62551000",
                email: "franz.torrez@bolcore.com",
                invoicename: "yam",
                invoicenumber: "22222",
                dni: "5958217",
                cardnumber: "4111111111111111",
                expiremonth: "12",
                expireyear: "2024",
            };
        }

        if (formpersonaldata) {
            const loadForm = async () => {
                let formData = await prepareForm(formpersonaldata);
                formData = mergeFormData(formData, userInfo);
                let initialValues = {};
                formData.map(function (key, item) {
                    initialValues[key.name] = key.value;
                });
                setPersonaldata({data: formData, formValues: initialValues});
            };
            loadForm();
        }

        if (formpaymentdata) {
            const loadForm2 = async () => {
                let formData = await prepareForm(formpaymentdata);
                formData = mergeFormData(formData, userInfo);
                let initialValues = {};
                formData.map(function (key, item) {
                    initialValues[key.name] = key.value;
                });
                setPaymentdata({data: formData, formValues: initialValues});
            };
            loadForm2();
        }
    };

    let oldAmount = 0;
    let {newamount} = useParams();

    useEffect(() => {
        setTimeout(() => window.scrollTo(0, 0), 100);
        if (amount && amount > 0 && amount !== oldAmount) {
            oldAmount = amount;
            window.fbq('track', 'InitiateCheckout');
            window.gtag("event", "generate_lead", {
                currency: "BOB",
                value: amount
            });
        }
    }, [amount]);

    useEffect(() => {
        let utm_source = getCookie(process.env.REACT_APP_NAME + "utm_source");
        let stepValues = {amount: parseInt(amount), step: "init-donation", utm_source: utm_source};
        simplePutData(EndPoint.setStep, stepValues);
        if (newamount) {
            if (isNaN(newamount)) {
                navigate("/lapolerademessi");
            } else {
                if (newamount < 50) {
                    navigate("/lapolerademessi");
                }
            }
            setAmount(newamount);
        }

        loadData();

        var _tmpOrder = getCookie(process.env.REACT_APP_NAME + "_DFP_session_id");
        if (!_tmpOrder) {
            try {
                window.reload();
            } catch (exc) {}
        }
        setTmpOrder(_tmpOrder);
    }, []);

    const currentStep = getCurrentStep();

    return (
        <>
            <BootstrapDialog onClose={handleClose} aria-labelledby="dialog-title" open={open}>
                <BootstrapDialogTitle id="dialog-title" onClose={handleClose}>
                    ATENCI&Oacute;N
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <Typography gutterBottom>Estimado cliente:</Typography>
                    <Typography gutterBottom>{errMessage}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose}>Entendido</Button>
                </DialogActions>
            </BootstrapDialog>

            <div className="messi-checkout-wrapper">
                {/* Animated Banner */}
                <AnimationBanner step={currentStep}/>

                {/* Ticket Counter */}
                {newamount && <TicketBanner amount={newamount}/>}

                {/* Step Indicator */}
                <div className="messi-steps">
                    <div className={`messi-step-dot ${currentStep === 'personal' ? 'active' : 'done'}`}/>
                    <div className={`messi-step-dot ${currentStep === 'payment' ? 'active' : currentStep === 'qr' ? 'done' : ''}`}/>
                    <div className={`messi-step-dot ${currentStep === 'qr' ? 'active' : ''}`}/>
                </div>

                {/* Checkout Card */}
                <div className="messi-checkout-card">
                    <Typography mb={1} style={{fontSize: "1rem", fontWeight: 600, color: '#0A1E3C'}}>
                        HARÁS UNA DONACIÓN DE: {newamount ? <span
                        style={{color: "#00AEEF", fontWeight: "bold", fontSize: "1.2rem"}}>{"Bs " + newamount}</span> : ""}
                    </Typography>

                    {showCyberFrame ?
                        <iframe width={370} height={650} style={{"borderStyle": "none"}}
                                src={process.env.REACT_APP_API_CONFIG + "/public/payments/getPaymentCyber/" + paymentToken}>
                        </iframe>
                        :
                        <>
                            {!newamount &&
                                <Container>
                                    <Grid container spacing={1} mt={4} mb={6}>
                                        <Grid item lg={3} xs={6}>
                                            <Button fullWidth variant="contained"
                                                    sx={{
                                                        height: 55, borderRadius: 8, fontSize: 20, fontWeight: 700,
                                                        backgroundColor: amount === 150 ? "#00AEEF" : "#FFFA2F",
                                                        color: amount === 150 ? "#fff" : "#000",
                                                        '&:hover': {backgroundColor: "#00AEEF", color: "#fff"}
                                                    }}
                                                    onClick={() => { setAmount(150); setShowAmount(false); }}>
                                                Bs 150
                                            </Button>
                                        </Grid>
                                        <Grid item lg={3} xs={6}>
                                            <Button fullWidth variant="contained"
                                                    sx={{
                                                        height: 55, borderRadius: 8, fontSize: 20, fontWeight: 700,
                                                        backgroundColor: amount === 250 ? "#00AEEF" : "#FFFA2F",
                                                        color: amount === 250 ? "#fff" : "#000",
                                                        '&:hover': {backgroundColor: "#00AEEF", color: "#fff"}
                                                    }}
                                                    onClick={() => { setAmount(250); setShowAmount(false); }}>
                                                Bs 250
                                            </Button>
                                        </Grid>
                                        <Grid item lg={3} xs={6}>
                                            <Button fullWidth variant="contained"
                                                    sx={{
                                                        height: 55, borderRadius: 8, fontSize: 20, fontWeight: 700,
                                                        backgroundColor: amount === 500 ? "#00AEEF" : "#FFFA2F",
                                                        color: amount === 500 ? "#fff" : "#000",
                                                        '&:hover': {backgroundColor: "#00AEEF", color: "#fff"}
                                                    }}
                                                    onClick={() => { setAmount(500); setShowAmount(false); }}>
                                                Bs 500
                                            </Button>
                                        </Grid>
                                        <Grid item lg={3} xs={6}>
                                            <Button fullWidth variant="contained"
                                                    sx={{
                                                        height: 55, borderRadius: 8, fontSize: 20, fontWeight: 700,
                                                        backgroundColor: amount !== 150 && amount !== 250 && amount !== 500 ? "#00AEEF" : "#FFFA2F",
                                                        color: amount !== 150 && amount !== 250 && amount !== 500 ? "#fff" : "#000",
                                                        '&:hover': {backgroundColor: "#00AEEF", color: "#fff"}
                                                    }}
                                                    onClick={() => { setAmount(50); setShowAmount(true); }}>
                                                Otro
                                            </Button>
                                        </Grid>
                                        {showAmount &&
                                            <Grid item lg={12} xs={12} mt={4}>
                                                <TextField fullWidth label={"Monto a Donar (Expresado en Bolivianos)"}
                                                           value={amount} onChange={handleChange}/>
                                            </Grid>
                                        }
                                    </Grid>
                                </Container>
                            }

                            {personaldata.data?.length > 0 && !personaldataSuccQR &&
                                <>
                                    {personaldataSucc ?
                                        ""
                                        : <GenericForm buttonClassName="btn-success" allDisabled={false}
                                                     buttonLabel={"Pago Con Tarjeta"}
                                                     buttonLabel2={"Pago con QR"}
                                                     button2ClassName={"btn-success"}
                                                     action={confirmPersonalData}
                                                     action2={confirmPersonalDataQR}
                                                     button2Position={"right"}
                                                     buttonPosition={"left"}
                                                     button2Padding={"0 5px 0 0px"}
                                                     buttonPadding={"0 0px 0 5px"}
                                                     buttonwidth={fullScreen2 ? "100%" : "initial"}
                                                     buttonwidth2={fullScreen2 ? "100%" : "initial"}
                                                     formData={personaldata}
                                                     addAcceptTerms={true}
                                                     checkedP={checkedP}
                                                     handleChangeP={handleChangeP}
                                                     componentName={"personalData"} id={1}/>
                                    }
                                </>
                            }

                            {personaldataSucc && paymentdata.data?.length > 0 &&
                                <GenericForm loading={loading}
                                             callbackHandleChange={callbackHandleChange}
                                             buttonLabel={noButton ? "NOBUTTON" : defConfig[defLang].paylabel}
                                             buttonLoadingLabel={noButton ? "NOBUTTON" : defConfig[defLang].validatingpaymentlabel}
                                             action={confirmPayment}
                                             buttonLabel2={defConfig[defLang].backlabel}
                                             action2={() => {
                                                 setPersonaldataSucc(false);
                                                 setPersonaldataSuccQR(false);
                                             }}
                                             buttonwidth={fullScreen2 ? "100%" : "initial"}
                                             buttonwidth2={fullScreen2 ? "100%" : "initial"}
                                             formData={paymentdata}
                                             inheritedformData={formData}
                                             componentName={"checkout"} id={1}/>
                            }

                            {personaldataSuccQR && (
                                <div style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width: "100%",
                                    textAlign: "center",
                                    paddingTop: "20px"
                                }}>
                                    {loadingQR && (
                                        <>
                                            <div>
                                                <CircularProgress color="secondary"/>
                                                <CircularProgress color="success"/>
                                                <CircularProgress color="inherit"/>
                                            </div>
                                            <b>Estamos generando el c&oacute;digo QR por favor espere unos segundos.</b>
                                        </>
                                    )}

                                    {!loadingQR && errorQR && (
                                        <>
                                            <b>Hubo un Error Generando el QR, Por Favor Intente Nuevamente.</b>
                                            <div>
                                                <LoaderButton
                                                    className={"btn-success"}
                                                    style={{paddingTop: "10px"}}
                                                    width={"300px"}
                                                    onClick={() => confirmPersonalDataQR(stepQRValues)}
                                                    label={"Reintentar"}
                                                    loadingLabel={"Cargando"}
                                                />
                                            </div>
                                        </>
                                    )}

                                    {!loadingQR && !errorQR && (
                                        <>
                                            <img src={`data:image/jpeg;base64,${imageQr}`} style={{maxWidth: "300px"}}/>
                                            <p>QR v&aacute;lido hasta el d&iacute;a {format(new Date(new Date().getTime() + 24 * 60 * 60 * 1000), 'dd/MM/yyyy')}</p>
                                            <div>
                                                <LoaderButton
                                                    className={"btn-success"}
                                                    style={{paddingTop: "10px"}}
                                                    width={"300px"}
                                                    onClick={() => {
                                                        let a = document.createElement("a");
                                                        a.href = "data:image/png;base64," + imageQr;
                                                        a.download = "DonacionQRUnicef.png";
                                                        a.click();
                                                    }}
                                                    label={"Descargar"}
                                                    loadingLabel={"Cargando"}
                                                />
                                            </div>
                                            <div style={{marginTop: "15px"}}>
                                                <LoaderButton
                                                    className={"btn-success"}
                                                    style={{paddingTop: "10px"}}
                                                    loading={isLoadingVerificar}
                                                    width={"300px"}
                                                    onClick={async () => {
                                                        try {
                                                            setIsLoadingVerificar(true);
                                                            let data = {idQr: idQR};
                                                            let response = await simplePostData(EndPoint.verificarQR, data);
                                                            let responseData = response.data.result[0];
                                                            if (responseData.STATUSID === 4) {
                                                                setMensajeQR("Pago en QR Recibido");
                                                                let UTM_ID = responseData.UTM_ID;
                                                                let UTM_SOURCE = responseData.UTM_SOURCE;
                                                                let UTM_MEDIUM = responseData.UTM_MEDIUM;
                                                                let UTM_CAMPAIGN = responseData.UTM_CAMPAIGN;
                                                                let UTM_CONTENT = responseData.UTM_CONTENT;

                                                                var utmData = "";
                                                                if (UTM_ID) utmData += "&utm_id=" + UTM_ID;
                                                                if (UTM_SOURCE) utmData += "&utm_source=" + UTM_SOURCE;
                                                                if (UTM_MEDIUM) utmData += "&utm_medium=" + UTM_MEDIUM;
                                                                if (UTM_CAMPAIGN) utmData += "&utm_campaign=" + UTM_CAMPAIGN;
                                                                if (UTM_CONTENT) utmData += "&utm_content=" + UTM_CONTENT;

                                                                window.location.href = process.env.REACT_APP_URL_CONFIG + '/donacion-messi-realizada?orderid=' + responseData.ORDERID + '&name=' + responseData.FIRSTNAME + '&email=' + responseData.EMAIL + '&amount=' + responseData.AMOUNT + utmData;
                                                            } else {
                                                                setMensajeQR("Pago en QR No Recibido");
                                                            }
                                                            setIsLoadingVerificar(false);
                                                        } catch (e) {
                                                            setIsLoadingVerificar(false);
                                                            setMensajeQR("Hubo un Error");
                                                        }
                                                    }}
                                                    label={"Verificar Pago"}
                                                    loadingLabel={"Cargando"}
                                                />
                                            </div>
                                            <br/>
                                            <b>{mensajeQR}</b>
                                        </>
                                    )}
                                </div>
                            )}
                            <span> {error} </span>
                        </>
                    }
                </div>

                {/* Sorteo reminder below the card */}
                <SorteoReminder/>
            </div>

            <form id="formCyberMessi" action={process.env.REACT_APP_cyberPostUrl} method="post">
                <input type={fieldType} name="access_key" value={finalData.access_key}/>
                <input type={fieldType} name="profile_id" value={finalData.profile_id}/>
                <input type={fieldType} name="transaction_uuid" value={finalData.transaction_uuid}/>
                <input type={fieldType} name="signed_field_names" value={finalData.signed_field_names}/>
                <input type={fieldType} name="unsigned_field_names" value={finalData.unsigned_field_names}/>
                <input type={fieldType} name="signed_date_time" value={finalData.signed_date_time}/>
                <input type={fieldType} name="locale" value={finalData.locale}/>
                <input type={fieldType} name="merchant_defined_data1" value={finalData.merchant_defined_data1}/>
                <input type={fieldType} name="merchant_defined_data2" value={finalData.merchant_defined_data2}/>
                <input type={fieldType} name="merchant_defined_data3" value={finalData.merchant_defined_data3}/>
                <input type={fieldType} name="merchant_defined_data4" value={finalData.merchant_defined_data4}/>
                <input type={fieldType} name="merchant_defined_data6" value={finalData.merchant_defined_data6}/>
                <input type={fieldType} name="merchant_defined_data7" value={finalData.merchant_defined_data7}/>
                <input type={fieldType} name="merchant_defined_data9" value={finalData.merchant_defined_data9}/>
                <input type={fieldType} name="merchant_defined_data10" value={finalData.merchant_defined_data10}/>
                <input type={fieldType} name="merchant_defined_data11" value={finalData.merchant_defined_data11}/>
                <input type={fieldType} name="merchant_defined_data12" value={finalData.merchant_defined_data12}/>
                <input type={fieldType} name="merchant_defined_data14" value={finalData.merchant_defined_data14}/>
                <input type={fieldType} name="merchant_defined_data15" value={finalData.merchant_defined_data15}/>
                <input type={fieldType} name="merchant_defined_data17" value={finalData.merchant_defined_data17}/>
                <input type={fieldType} name="merchant_defined_data18" value={finalData.merchant_defined_data18}/>
                <input type={fieldType} name="merchant_defined_data19" value={finalData.merchant_defined_data19}/>
                <input type={fieldType} name="merchant_defined_data87" value={finalData.merchant_defined_data87}/>
                <input type={fieldType} name="merchant_defined_data88" value={finalData.merchant_defined_data88}/>
                <input type={fieldType} name="merchant_defined_data90" value={finalData.merchant_defined_data90}/>
                <input type={fieldType} name="merchant_defined_data91" value={finalData.merchant_defined_data91}/>
                <input type={fieldType} name="device_fingerprint_id" value={finalData.device_fingerprint_id}/>
                <input type={fieldType} name="transaction_type" value={"sale"}/>
                <input type={fieldType} name="reference_number" value={finalData.reference_number}/>
                <input type={fieldType} name="amount" id="amount" value={finalData.amount}/>
                <input type={fieldType} name="currency" id="currency" value={finalData.currency}/>
                <input type={fieldType} name="payment_method" value={finalData.payment_method}/>
                <input type={fieldType} name="bill_to_email" value={finalData.bill_to_email}/>
                <input type={fieldType} name="bill_to_phone" value={finalData.bill_to_phone}/>
                <input type={fieldType} name="bill_to_address_line1" value={finalData.bill_to_address_line1}/>
                <input type={fieldType} name="bill_to_address_city" value={finalData.bill_to_address_city}/>
                <input type={fieldType} name="bill_to_address_state" value={finalData.bill_to_address_state}/>
                <input type={fieldType} name="bill_to_address_country" value={finalData.bill_to_address_country}/>
                <input type={fieldType} name="bill_to_address_postal_code" value={finalData.bill_to_address_postal_code}/>
                <input type={fieldType} name="override_custom_receipt_page" value={finalData.override_custom_receipt_page}/>
                <input type={fieldType} name="override_backoffice_post_url" value={finalData.override_backoffice_post_url}/>
                <input type={fieldType} name="card_type" value={finalData.card_type}/>
                <input type={fieldType} name="bill_to_forename" value={finalData.bill_to_forename}/>
                <input type={fieldType} name="bill_to_surname" value={finalData.bill_to_surname}/>
                <input type={fieldType} name="card_number" value={formData.cardnumber}/>
                <input type={fieldType} name="card_expiry_date" value={formData.expiremonth + "-" + formData.expireyear}/>
                <input type={fieldType} name="card_cvn" value={formData.cvv}/>
                <input type={fieldType} name="signature" value={signature}/>
            </form>
        </>
    );
};

MessiCheckout.propTypes = {};

export default MessiCheckout;
